import axiosInstance from './api'
import TokenService from './tokenService'
import Vue from 'vue'
import {bus} from "../main";

const setup = (store, router) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = TokenService.getLocalAccessToken()
      if(config.url.includes("hooks.slack")){
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'; // <--- 6.1 ICI
      }
      else {
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token
        }

      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axiosInstance.interceptors.response.use(
    (res) => {
      return res
    },
    async (err) => {
      const originalConfig = err.config

      // Refresh Token expired
      if ((err.response.status === 403 || err.response.status === 401) && originalConfig.url === '/oauth/access_token') {
        await store.dispatch('LogOut')
        router.push('/login')
      } else if (originalConfig.url !== '/api/login' && originalConfig.url !== '/forgotPassword/resetPassword' && originalConfig.url !== '/oauth/access_token' && err.response) {
        // Access Token expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true

          try {
            TokenService.removeLocalAccessToken()
            const params = new URLSearchParams()
            params.append('grant_type', 'refresh_token')
            params.append('refresh_token', TokenService.getLocalRefreshToken())

            const res = await axiosInstance({
              method: 'POST',
              url: '/oauth/access_token',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              data: params
            })

            store.dispatch('refreshToken', res)

            return axiosInstance(originalConfig)
          } catch (_error) {
            return Promise.reject(_error)
          }
        }
        else if (err.response.status === 500 || err.response.status === 404) {
          const vm = new Vue()
          const a = vm.$createElement;

          const message = a('div', {}, [
            'Veuillez réessayer ultérieurement. Si l\'erreur persiste, merci de  ',
            a('a', {
              attrs: {
                href: "#"
              },
              on: {
                click: (event) => {
                  if(['preprod', 'production'].includes(process.env.NODE_ENV)){
                    bus.$emit('showBugReportModal');
                  }
                }
              }
            }, 'signaler ce bug')
          ]);

          vm.$bvToast.toast(message, {
            title: "Une erreur s'est produite.",
            autoHideDelay: 20000,
            toaster: 'b-toaster-bottom-right',
            variant:"danger",
            solid:true,
          })

        }
      }

      return Promise.reject(err)
    }
  )
}

export default setup



// WEBPACK FOOTER //
// ./src/services/setupInterceptors.js